<!--
 * @Description: 业务说明
 * @Date: 2023-08-21 18:00:11
-->
<template>
  <el-dialog
    center
    title=""
    :visible="true"
    :before-close="() => $emit('close')"
    top="11vh"
    width="1800px"
  >
    <div
      v-for="(row, index) in descList2DArray"
      :key="index"
      class="row"
      :style="{
        flexDirection: index % 2 === 1 ? 'row-reverse' : 'row'
      }"
    >
      <div ref="box" v-for="(item, cindex) in row" :key="item" class="box">
        <div class="box__number">
          <span>{{ findNumber(item) }}</span>
        </div>
        <span class="desc" v-html="item"></span>
        <div
          v-if="showRightArrows(index, cindex, findNumber(item))"
          :style="{
            transform: index % 2 === 1 ? 'rotate(180deg)' : 'rotate(0deg)'
          }"
          class="box__jiantou"
        ></div>
        <div
          v-if="showButtomArrows(index, cindex)"
          class="box__jiantouxia"
        ></div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getBusinessDesc } from './businessDescMap';

function convertTo2DArray(arr, size = 5) {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
}

function getMaxHeight(elements) {
  let maxHeight = 0;

  for (let i = 0; i < elements.length; i++) {
    const element = elements[i];
    const style = window.getComputedStyle(element);
    const height = parseFloat(style.height) || 0;

    if (height > maxHeight) {
      maxHeight = height;
    }
  }

  return maxHeight;
}

export default {
  name: 'BusinessDescription',
  props: {
    businessDesc: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      descList: []
    };
  },
  computed: {
    descList2DArray() {
      const arr = convertTo2DArray(this.descList);
      return arr;
    }
  },
  methods: {
    // 最后一列隐藏向右的箭头
    showRightArrows(index, cindex, number) {
      if (index % 2 === 1 && cindex === 0) {
        return false;
      }
      if (index % 2 === 0 && cindex === 4) {
        return false;
      }
      if (index % 2 === 0 && number === this.descList.length) {
        return false;
      }
      return true;
    },
    // 隐藏向下的箭头
    showButtomArrows(index, cindex) {
      if (index + 1 !== this.descList2DArray.length && cindex === 4) {
        return true;
      }
      return false;
    },
    // 序号
    findNumber(item) {
      return this.descList.findIndex(v => v === item) + 1;
    }
  },
  created() {
    this.descList = getBusinessDesc(this.businessDesc);
  },
  mounted() {
    this.$nextTick(() => {
      const maxHeight = getMaxHeight(this.$refs.box); // 获取最大高度
      this.$refs.box.forEach(item => {
        item.style.height = maxHeight + 'px'; // 设置高度
      });
    });
  }
};
</script>

<style scoped lang="scss">
.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  margin: 50px 25px;
}
.box {
  width: 280px;
  margin: 0 30px;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #d7d7d7;
  box-sizing: border-box;
  padding: 20px 25px;
  display: flex;
  align-items: center;
  position: relative;
  &__number {
    width: 40px;
    height: 40px;
    position: absolute;
    left: -20px;
    background-image: url('//cdn.yxvzb.com/WEB/SaaS/images/mgmt/liubianxing.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    text-align: center;
    color: white;
    line-height: 40px;
    font-size: 20px;
    font-weight: 700;
  }
  &__jiantou {
    width: 20px;
    height: 20px;
    position: absolute;
    right: -34px;
    background-image: url('//cdn.yxvzb.com/WEB/SaaS/images/mgmt/jiantouyou.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  &__jiantouxia {
    width: 20px;
    height: 20px;
    position: absolute;
    right: calc(50% - 10px);
    bottom: -35px;
    background-image: url('//cdn.yxvzb.com/WEB/SaaS/images/mgmt/jiantouxia.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}
</style>
